/** Horizontal inset per attachment nesting level (one indent step per depth). */
export const kEmailAttachmentNameIndentPx = 32
